export const setGALocation = (page) => {
	switch (page) {
		case "nav":
			return "Header";
		case "global-splash":
			return "Global Splash";
		case "unknown-splash":
			return "Unknown Splash";
		default:
			return page;
	}
};
